import * as React from 'react';

const styles = require('../assets/less/layout.less');

export default () => (
  <React.Fragment>
    <div className="header">
      <div className="background">
        <div id="name">Billy Rhoades</div>
      </div>
    </div>
  </React.Fragment>
);
